require('slick-carousel');
require('bootstrap');

import AOS from 'aos';

var $ = require( "jquery" );
var player = [];


window.addEventListener('load', function(){

    AOS.init({
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
        initClassName: 'aos-init', // class applied after initialization
        animatedClassName: 'aos-animate', // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 0, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 700, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: false, // whether animation should happen only once - while scrolling down
        mirror: true, // whether elements should animate out while scrolling past them
        anchorPlacement: 'center-bottom', // defines which position of the element regarding to window should trigger the animation);
    });

    setTimeout(function (){
        AOS.refresh();
    },3000);

});

$(document).ready(function (){
    var hash = window.location.hash;
    var didScroll = false;

    if (location.hash) {
        setTimeout(function() {
            window.scrollTo(0, 0);
        }, 1);
    }

    if($('.flash-banner').length){
        var banner = $('.flash-banner').outerHeight();
        var nav = $('header').outerHeight();
    }

    if(hash){
        setTimeout(function (){
            var element = $(hash);
            if(element.length > 0){
                var height = $('header').height();
                var scrollto = element.offset().top - height + 1;
                $('html,body').animate({scrollTop: scrollto}, 700);
                didScroll = true;
            }
        },100)
    }


   $('.four-slider').slick({
        slidesToScroll:1,
        speed: 800,
        slidesToShow:4,
        dots:false,
        arrows:true,
        autoplay:false,
        nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="30" viewBox="0 0 17 30"  class="next-arrow">\n' +
            '  <g data-name="Group 1497">\n' +
            '    <g data-name="Group 1498">\n' +
            '      <path fill="#d8d8d8" d="M4.9 2.2 3.245.556C1.528-1.155-1.166 1.47.55 3.18l11.531 11.494.337.336L2.2 25.192.55 26.841c-1.715 1.71.977 4.336 2.7 2.624l11.526-11.494 1.654-1.648a1.852 1.852 0 0 0 0-2.624L4.9 2.2" data-name="Path 794"/>\n' +
            '    </g>\n' +
            '  </g>\n' +
            '</svg>\n',
        prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="30" viewBox="0 0 17 30" class="prev-arrow">\n' +
            '  <g data-name="Group 1499">\n' +
            '    <g data-name="Group 1498">\n' +
            '      <path fill="#d8d8d8" d="m12.075 27.822 1.655 1.644c1.717 1.711 4.411-.914 2.695-2.624L4.894 15.348l-.337-.336L14.775 4.83l1.65-1.649c1.715-1.71-.977-4.336-2.7-2.624L2.199 12.051.545 13.699a1.852 1.852 0 0 0 0 2.624l11.53 11.499" data-name="Path 794"/>\n' +
            '    </g>\n' +
            '  </g>\n' +
            '</svg>\n',
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll:1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll:1,
                }
            },
        ]
    });

   $('.quote-slider').slick({
        slidesToScroll:1,
        speed: 800,
        slidesToShow:1,
        dots:true,
        arrows:true,
        autoplay:false,
        nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="30" viewBox="0 0 17 30"  class="next-arrow">\n' +
            '  <g data-name="Group 1497">\n' +
            '    <g data-name="Group 1498">\n' +
            '      <path fill="#d8d8d8" d="M4.9 2.2 3.245.556C1.528-1.155-1.166 1.47.55 3.18l11.531 11.494.337.336L2.2 25.192.55 26.841c-1.715 1.71.977 4.336 2.7 2.624l11.526-11.494 1.654-1.648a1.852 1.852 0 0 0 0-2.624L4.9 2.2" data-name="Path 794"/>\n' +
            '    </g>\n' +
            '  </g>\n' +
            '</svg>\n',
        prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="30" viewBox="0 0 17 30" class="prev-arrow">\n' +
            '  <g data-name="Group 1499">\n' +
            '    <g data-name="Group 1498">\n' +
            '      <path fill="#d8d8d8" d="m12.075 27.822 1.655 1.644c1.717 1.711 4.411-.914 2.695-2.624L4.894 15.348l-.337-.336L14.775 4.83l1.65-1.649c1.715-1.71-.977-4.336-2.7-2.624L2.199 12.051.545 13.699a1.852 1.852 0 0 0 0 2.624l11.53 11.499" data-name="Path 794"/>\n' +
            '    </g>\n' +
            '  </g>\n' +
            '</svg>\n',
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll:1,
                }
            },
        ]
    });


   $('.featured-slider').slick({
        slidesToScroll:2,
        speed: 800,
        slidesToShow:4,
        dots:true,
        arrows:true,
        autoplay:false,
        nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="30" viewBox="0 0 17 30"  class="next-arrow">\n' +
            '  <g data-name="Group 1497">\n' +
            '    <g data-name="Group 1498">\n' +
            '      <path fill="#d8d8d8" d="M4.9 2.2 3.245.556C1.528-1.155-1.166 1.47.55 3.18l11.531 11.494.337.336L2.2 25.192.55 26.841c-1.715 1.71.977 4.336 2.7 2.624l11.526-11.494 1.654-1.648a1.852 1.852 0 0 0 0-2.624L4.9 2.2" data-name="Path 794"/>\n' +
            '    </g>\n' +
            '  </g>\n' +
            '</svg>\n',
        prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="30" viewBox="0 0 17 30" class="prev-arrow">\n' +
            '  <g data-name="Group 1499">\n' +
            '    <g data-name="Group 1498">\n' +
            '      <path fill="#d8d8d8" d="m12.075 27.822 1.655 1.644c1.717 1.711 4.411-.914 2.695-2.624L4.894 15.348l-.337-.336L14.775 4.83l1.65-1.649c1.715-1.71-.977-4.336-2.7-2.624L2.199 12.051.545 13.699a1.852 1.852 0 0 0 0 2.624l11.53 11.499" data-name="Path 794"/>\n' +
            '    </g>\n' +
            '  </g>\n' +
            '</svg>\n',
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll:1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll:1,
                }
            },
        ]
    });



    // checkPos();
    //
    // setTimeout(function (){
    //     $('nav > ul > li').each(function () {
    //         var pos = $(this).offset();
    //         $(this).find('.subnav').css({
    //             'padding-left': pos.left + 'px',
    //         });
    //         return false;
    //     });
    //     $('.subnav').addClass('loaded');
    // },2000);
    //

    $(document).on('mouseover', '.top-link', function () {
        if($(window).width() > 768) {
            $('.subnav.show').removeClass('show');
            $('nav .hover').removeClass('hover');

            $(this).next('.subnav').addClass('show');
//            $(this).next('.hassubsub').find('.sublink').first().trigger('mouseover');
            $(this).addClass('hover');
            return false;
        }
    });

    $(document).on('mouseover', '.sublink', function () {
        if($(window).width() > 768) {
            $('.subsubnav.show').removeClass('show');
            $('.sublink.hover').removeClass('hover');

            $(this).find('.subsubnav').addClass('show');
            $(this).addClass('hover');
            return false;
        }
    });

    $(document).on('mouseover', '.page', function () {
        if($(window).width() > 768) {
            $('.subnav').removeClass('show');
            $('nav .hover').removeClass('hover');
            return false;
        }
    });


    $(document).on('click', '.hamburger', function () {
        $('nav').toggleClass('open');
        $('.hamburger').toggleClass('open');
        $('header').toggleClass('open');
        return false;
    });

    $(document).on('click', '.scrollto', function () {
        var element = $($(this).attr('href'));
        var height = $('header').height();
        var scrollto = element.offset().top - height + 1;
        $('html,body').animate({scrollTop: scrollto}, 700);
        didScroll = true;
        $('nav').removeClass('open')
        return false;
    });

    // $(window).scroll(function() {
    //     didScroll = true;
    // });
    //
    // setInterval(function() {
    //     if ( didScroll ) {
    //         didScroll = false;
    //         checkPos();
    //     }
    // }, 450);

    $(document).on('click','.filter-all',function (){
        $('.left,.right').addClass('active');
        $('.filter').removeClass('selected');
        $(this).addClass('selected');
        doSearch();
    });


    document.addEventListener('aos:in:load-more', ({ detail }) => {
        $('.load-insights').remove();
        var cats = [];
        var search = $('.keyword').val();
        $('.filter.selected').each(function (){
            cats.push($(this).attr('data-cat'));
        })

        $.post(detail.getAttribute('data-load-url'),{cats:cats,search:search},function (data){
            $('.insights').append(data);
            AOS.refresh();
        });
    });

    $(document).on('click','.filter-all',function (){
        $('.left,.right').addClass('active');
        $('.filter').removeClass('selected');
        $(this).addClass('selected');
        doSearch();

    });


    $(document).on('click','.filter-single',function (){
        $('.left,.right').addClass('active');
        $('.filter-all').removeClass('selected');
        $(this).toggleClass('selected');
        if($('.filter.selected').length == 0){
            $('.filter-all').addClass('selected');
        }
        doSearch();
    });

    $(document).on('keyup','.keyword',function (){
        doSearch();
    });

    $('.accordion').on('click','.accord-heading', function() {
        if($(this).hasClass('active')){
            $(this).next('.accord-content').slideUp();
            $(this).removeClass('active');
        }else{
            $('.accord-heading').removeClass('active');
            $(this).parent().find('.accord-content').slideUp();
            $(this).next('.accord-content').slideDown();
            $(this).addClass('active')
        }
        return false;
    });


})


var jqxhr;
function doSearch(){
    if(typeof(jqxhr) != 'undefined'){
        jqxhr.abort()
    }
    var cats = [];
    var search = $('.keyword').val();
    $('.filter.selected').each(function (){
        cats.push($(this).attr('data-cat'));
    })

    const firstPath = window.location.pathname.split('/')[1];
    if(cats[0] != 'all'){
        window.history.pushState({}, '', '/'+firstPath+'?cats='+cats);
    }else{
        window.history.pushState({}, '', '/'+firstPath);
    }

    jqxhr = $.post('/load-articles',{cats:cats,search:search},function (data){
        $('.insights').html(data);
    });

}


setTimeout(function (){
if (window.getCkyConsent) {
    var consent = window.getCkyConsent();
  if (consent.categories.analytics) {
        console.log('analytics allowed');
        $('body').append('<script src="https://player.vimeo.com/api/player.js"></script>');
        $('body').append('<script src="https://www.youtube.com/iframe_api"></script>');
         $('iframe').each(function (){
                if($(this).attr("src") && $(this).attr('src').indexOf('youtube.com') > 0){
                    var src = $(this).attr('src');
                    src = src.replace('youtube.com','youtube-nocookie.com');
                    $(this).attr('src',('src',src+'?enablejsapi=1'));
                }
            });

             $(document).on('click','.video-link',function (){
                    var vid = $(this).attr('href');
                    var oldId = '#'+$('#video-popup .content.active-video').attr('id');
                    var oldiframe = $('#video-popup .content.active-video iframe')[0];

                    // console.log('OLD'+oldId);
                    // console.log('OLD'+oldiframe);
                    console.log(player);
                    //
                    $('#video-popup .content').removeClass('active-video');
                    $('#video-popup .video-link').removeClass('active-video');
                    $(vid).addClass('active-video');
                    $(this).addClass('active-video')

                    var newiframe = $('#video-popup .content.active-video iframe')[0];

                    //pause old
                    if(typeof player[oldId] == 'undefined'){
                        player[oldId] = new YT.Player(oldiframe, {
                            events: {
                                'onReady': function (event){
                                    event.target.pauseVideo();
                                }
                            }
                        });
                    }else{
                        console.log(player[oldId]);
                        player[oldId].pauseVideo();
                    }

                    //play new
                    if(typeof player[vid] == 'undefined'){
                        player[vid] = new YT.Player(newiframe, {
                            events: {
                                'onReady': function (event){
                                    event.target.playVideo();
                                }
                            }
                        });
                    }else{
                        player[vid].playVideo();
                    }

                    return false;
                });

                $(document).on('click','.modal-get',function (){
                    var href = $(this).attr('href');
                    $('#video-popup .loaded').load(href,function (){
                        $('#video-popup').modal('show');
                        if ($('#video-popup script').length > 0) {
                            const widgetScript = $('#video-popup script').eq(1).text();
                            eval(widgetScript)
                        }
                    })
                    return false;
                });

                $('#video-popup').on('show.bs.modal', function (e) {
                    $('iframe').each(function (){
                        if($(this).attr("src") && $(this).attr('src').indexOf('youtube.com') > 0){
                            var src = $(this).attr('src');
                            src = src.replace('youtube.com','youtube-nocookie.com');
                            $(this).attr('src',('src',src+'?enablejsapi=1'));
                        }
                    });
                    var newId = '#'+$('#video-popup .content.active-video').attr('id');
                    var newiframe = $('#video-popup .content.active-video iframe')[0];

                    //play new
                    if(typeof player[newId] == 'undefined'){
                        player[newId] = new YT.Player(newiframe, {
                            events: {
                                'onReady': function (event){
                                    event.target.playVideo();
                                }
                            }
                        });
                    }else{
                        player[newId].playVideo();
                    }

                })

                $('#video-popup').on('hide.bs.modal', function (e) {
                    $('#video-popup .loaded').html('');
                    player = [];
                });

                 $('iframe').each(function (){
                     if($(this).attr("src") && $(this).attr('src').indexOf('youtube.com') > 0){
                         var src = $(this).attr('src');
                         src = src.replace('youtube.com','youtube-nocookie.com');
                         $(this).attr('src',('src',src+'?enablejsapi=1'));
                     }
                     if($(this).attr("src") && $(this).attr('src').indexOf('vimeo.com') > 0){
                         var src = $(this).attr('src');
                         $(this).attr('src',('src',src+'?dnt=1'));
                     }
                 });

                $('.video').on('shown.bs.modal', function (e) {
                    var iframe = $(this).find('iframe')[0];
                    var id = $(this).attr('id');
                    if($(this).hasClass('vimeo')){
                        player[id] = new Vimeo.Player(iframe);
                        player[id].play();
                    }else{
                        console.log(typeof player[id]);
                        if(typeof player[id] == 'undefined'){
                            player[id] = new YT.Player(iframe, {
                                events: {
                                    'onReady': function (event){
                                        event.target.playVideo();
                                    }
                                }
                            });
                        }else{
                            player[id].playVideo();
                        }
                    }
                });
                $('.video').on('hide.bs.modal', function (e) {
                    var id = $(this).attr('id');
                    if($(this).hasClass('vimeo')) {
                        player[id].pause();
                    }else{
                        player[id].pauseVideo();
                    }
                });


    }else{
        console.log('videos not allowed');
        $('.video .modal-content').html('<p class="text-dark">Allow cookies to view videos</p>');
    }
}
},1000);
